import { render, staticRenderFns } from "./ButtonUser.vue?vue&type=template&id=71a9df1c&scoped=true"
import script from "./ButtonUser.vue?vue&type=script&lang=js"
export * from "./ButtonUser.vue?vue&type=script&lang=js"
import style0 from "./ButtonUser.vue?vue&type=style&index=0&id=71a9df1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9df1c",
  null
  
)

export default component.exports